import { useEffect, useState } from "react";

type CopyFn = (text: string) => Promise<boolean>;

export default function useCopyToClipboard(): { canCopy: boolean; copy: CopyFn } {
  const [canCopy, setCanCopy] = useState(false);

  useEffect(() => {
    if (!navigator?.clipboard) {
      setCanCopy(false);
    } else {
      setCanCopy(true);
    }
  }, []);

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      console.warn("Clipboard not supported");
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error("Failed to copy text: ", error);
      return false;
    }
  };

  return { canCopy, copy };
}
